import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
  AUTH_MAIN_ROUTE,
  AUTH_ROUTES,
} from '../../constants/auth.routing.constants';
import { FeatureFlagsService } from '../../services/feature-flags/feature-flags.service';
import { FEATURE_FLAG_KEY } from '../path-allowed-by-feature-flag/path-allowed-by-feature-flag.guard';

// Unlike pathAllowedByFeatureFlagGuard, redirects to login instead of leaving a blank page on direct visits.
export const featureFlagGuard: CanActivateFn = route => {
  const featureFlagsService = inject(FeatureFlagsService);
  const router = inject(Router);

  return featureFlagsService.getFeatureFlagValue(route.data[FEATURE_FLAG_KEY])
    ? true
    : router.createUrlTree(['/', AUTH_MAIN_ROUTE, AUTH_ROUTES.LOGIN]);
};
